import useSWR from "swr";
import * as z from "zod/mini";

import { dbFirestore } from "../../firestore";

const LOCALSTORAGE_KEY = "selectedRedeemGroupIds";

export const getSelectedRedeemGroupIds = (): string[] => {
  try {
    const stored = localStorage.getItem(LOCALSTORAGE_KEY);
    if (!stored) return [];
    const result = z.array(z.string()).safeParse(JSON.parse(stored));
    if (!result.success) return [];
    return result.data;
  } catch {
    return [];
  }
};

export const setSelectedRedeemGroupIds = (ids: string[]) => {
  localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(ids));
};

const fetchSelectedRedeemTicketIds = async (): Promise<string[]> => {
  const selectedGroupIds = getSelectedRedeemGroupIds();
  if (selectedGroupIds.length === 0) return [];

  const snapshot = await dbFirestore.ticketRedeemGroups().get();
  const groups = snapshot.docs
    .map((doc) => doc.data())
    .filter((data) => data !== null)
    .filter((group) => selectedGroupIds.includes(group._id));

  const ids = groups.flatMap((group) => group.ticketIds);
  return Array.from(new Set(ids));
};

/**
 * 選択されたもぎりグループに属するticketIdの一覧を返す
 */
export const useSelectedRedeemTicketIds = () => {
  return useSWR<string[], Error>(
    "selectedRedeemTicketIds",
    fetchSelectedRedeemTicketIds
  );
};
